import { observable, runInAction } from 'mobx';
import { createBrowserHistory } from 'history';
import { DataTypeReportZNS, IZNSServices, ZNSInfo, ZNSTemplate, ZaloTask, ZaloTemplate } from 'services/ZNS/zns_services';
import { DataResponse } from 'services/response';
import { CommonModel } from 'services/Main/common_services';



export const history = createBrowserHistory();

export type ZNSStore = {
  znsRespone: DataResponse<any>
  znsTemplateRespone: DataResponse<Array<ZNSTemplate>>
  dropdownZaloTaskRespone: DataResponse<Array<ZaloTask>>
  dropdownZaloTemplateRespone: DataResponse<Array<ZaloTemplate>>

  dropdownZnsTemplateRespone: DataResponse<Array<CommonModel>>
  dropdownNghiepVuTemplateRespone: DataResponse<Array<CommonModel>>

  znsReportRespone: DataResponse<Array<DataTypeReportZNS>>;
};

export interface IZNSPresenter {
  createStore(): ZNSStore;
  oaInfo(store: ZNSStore): Promise<any>;
  editOAInfo(store: ZNSStore, actived: boolean, oaId: string): Promise<any>;
  listZNSTemplate(store: ZNSStore, dataSearch: object): Promise<void>;
  listDropdownZaloTask(store: ZNSStore): Promise<void>;
  listDropdownZNSTemplate(store: ZNSStore): Promise<void>;
  listDropdownNghiepVuTemplate(store: ZNSStore): Promise<void>;
  syncZNS(store: ZNSStore, data: object): Promise<any>;
  detailZNSTemplate(store: ZNSStore, templateId: string): Promise<void>;

  reportSendZNS(store: ZNSStore, data: object): Promise<void>;

  exportReportZNS(data: object): Promise<void>;

}

export function createZNSPresenter({ znsServices }: { znsServices: IZNSServices }): IZNSPresenter {
  return {
    createStore: () =>
      observable({
        znsRespone: {
          data: undefined,
          isSuccess: false,
          message: '',
        },
        znsTemplateRespone: {
          data: [],
          paging: {
            totalCount: 0,
            totalPage: 0,
            pageSize: 0,
          },
          message: '',
          isSuccess: false,
        },
        dropdownZaloTaskRespone: {
          data: [],
          message: '',
          isSuccess: false,
        },
        dropdownZaloTemplateRespone: {
          data: [],
          message: '',
          isSuccess: false,
        },
        dropdownZnsTemplateRespone: {
          data: [],
          message: '',
          isSuccess: false,
        },
        dropdownNghiepVuTemplateRespone: {
          data: [],
          message: '',
          isSuccess: false,
        },
        znsReportRespone: {
          data: [],
          paging: {
            totalCount: 0,
            pageIndex: 0,
            pageSize: 0,
            totalPages: 0
          },
          message: '',
          isSuccess: false,
        },
      }),
    // Info OA after add new OA
    oaInfo: async (store) => {
      try {
        const result = await znsServices.oaInfo();
        runInAction(() => {
          store.znsRespone.data = result.data;
          store.znsRespone.message = result.message;
          store.znsRespone.isSuccess = result.isSuccess;
        });
      } catch {
        // error
        return false;
      }
    },
    // Edit oa info
    editOAInfo: async (store, actived, oaId) => {
      try {
        const result = await znsServices.editOAInfo(actived, oaId);
        runInAction(() => {
          store.znsRespone.data = result.data;
          store.znsRespone.message = result.message;
          store.znsRespone.isSuccess = result.isSuccess;
        });
      } catch {
        // error
        return false;
      }
    },
    listZNSTemplate: async (store, dataSearch) => {
      try {
        const result = await znsServices.listZNSTemplate(dataSearch);
        runInAction(() => {
          store.znsTemplateRespone.data = result.data;
          store.znsTemplateRespone.message = result.message;
          store.znsTemplateRespone.isSuccess = result.isSuccess;
          store.znsTemplateRespone.paging = {
            totalCount: result.paging?.pagesCount,
            recordsTotal: result.paging?.recordsTotal,
            pageSize: result.paging?.resultsCount,
          };
        });
      } catch (error) {
        console.log(error);
      }
    },
    listDropdownZaloTask: async (store) => {
      try {
        const result = await znsServices.listDropdownZaloTask();
        runInAction(() => {
          store.dropdownZaloTaskRespone.data = result.data;
          store.dropdownZaloTaskRespone.message = result.message;
          store.dropdownZaloTaskRespone.isSuccess = result.isSuccess;
        });
      } catch (error) {
        console.log(error);
      }
    },
    listDropdownZNSTemplate: async (store) => {
      try {
        const result = await znsServices.listDropdownZnsTemplate();
        runInAction(() => {
          store.dropdownZnsTemplateRespone.data = result.data;
          store.dropdownZnsTemplateRespone.message = result.message;
          store.dropdownZnsTemplateRespone.isSuccess = result.isSuccess;
        });
      } catch (error) {
        console.log(error);
      }
    },
    listDropdownNghiepVuTemplate: async (store) => {
      try {
        const result = await znsServices.listDropdownNghiepVuTemplate();
        runInAction(() => {
          store.dropdownNghiepVuTemplateRespone.data = result.data;
          store.dropdownNghiepVuTemplateRespone.message = result.message;
          store.dropdownNghiepVuTemplateRespone.isSuccess = result.isSuccess;
        });
      } catch (error) {
        console.log(error);
      }
    },

    // Edit oa info
    syncZNS: async (store, data) => {
      try {
        const result = await znsServices.syncZNS(data);
        runInAction(() => {
          store.znsRespone.data = result.data;
          store.znsRespone.message = result.message;
          store.znsRespone.isSuccess = result.isSuccess;
        });
      } catch (error) {
        console.log(error);
      }
    },
    // Detail ZNS Template
    detailZNSTemplate: async (store, templateId) => {
      try {
        const result = await znsServices.detailZNSTemplate(templateId);
        runInAction(() => {
          store.znsRespone.data = result.data;
          store.znsRespone.message = result.message;
          store.znsRespone.isSuccess = result.isSuccess;
        });
      } catch (error) {
        console.log(error);
      }
    },

    // Báo cáo ZNS
    reportSendZNS: async (store, data) => {
      try {
        const result = await znsServices.reportSendZNS(data);
        runInAction(() => {
          store.znsReportRespone.data = result.data;
          store.znsReportRespone.message = result.message;
          store.znsReportRespone.isSuccess = result.isSuccess;
          store.znsReportRespone.paging = result.paging;
        });
      } catch (error) {
        console.log(error);
      }
    },

    // Report báo cáo ZNS
    exportReportZNS: async (data) => {
      try {
        await znsServices.exportReportZNS(data);
      } catch (error) {
        console.log(error);
      }
    },

  };
}
